import { Container, Drawer } from '@mui/material';
import React from 'react';
import styles from '../Styles/Options.drawer.module.scss';
import BottomBarDrawer from './BottomBarDrawer';
import DrawerContent from './SettingDrawer/components/DrawerContent/DrawerContent';
import { useState } from 'react';
import LanguageEditor from './SettingDrawer/components/LanguageEditor/LanguageEditor';
import AccessControl from 'Global/security/AccessControl';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const OptionsDrawer = ({ IsDrawerOpen, setDrawerOpen }) => {
  const [showLangEditor, setShowLangEditor] =
    useState(false);
  const isLanguageEditAllowed = AccessControl(
    'edit-languauge-btn'
  );
  const close_lang_editor = FindLangKey(
    'general-public-not-found-return'
  );
  return (
    <React.Fragment>
      <Drawer
        variant="persistent"
        anchor="right"
        open={IsDrawerOpen}
        classes={{ paper: styles.ProfileDrawer }}
        hideBackdrop
        PaperProps={{
          sx: {
            background: themeColors.ColorSecondary,
          },
        }}
      >
        <BottomBarDrawer
          styles={styles}
          setDrawerOpen={setDrawerOpen}
          setShowLangEditor={setShowLangEditor}
        />
        {showLangEditor ? (
          isLanguageEditAllowed ? (
            <LanguageEditor
              setShowLangEditor={setShowLangEditor}
              closeEdtiorLabel={close_lang_editor}
            />
          ) : (
            <></>
          )
        ) : (
          <DrawerContent
            setShowLangEditor={setShowLangEditor}
          />
        )}
        <br />
      </Drawer>
    </React.Fragment>
  );
};

export default OptionsDrawer;
